import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable()
export class AuthGuardService implements CanActivate {

    constructor(private authService: AuthService, private router: Router) {
    }
    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.authService.isAuthenticated()
            .then(authenticated => {
                if (authenticated) {
                    return true;
                } else {
                    localStorage.setItem('auth_redirect_url', state.url);
                    this.router.navigate(['/login']);
                    return false;
                }
            });
    }
    // canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    //     const expectedRole = route.data.expectedRole;
    //     this.authService.getLoggedInUser().then(result => {
    //         if (result != null) {
    //             if (result.role !== expectedRole
    //             ) {
    //                 console.log('Unauthorized to open link: ' + state.url);
    //                 this.router.navigate(['/login']);
    //                 return false;
    //             }
    //         }
    //     });
    //     return true;
    // }
}

@Injectable()
export class RoleGuardService implements CanActivate {

    constructor(private authService: AuthService, private router: Router) {
    }
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const expectedRole = route.data.expectedRole;
        // tslint:disable-next-line:prefer-const
        let definehome: boolean;
        if (expectedRole[0] === 'WorkerSeller') {
            definehome = true;
        }

        this.authService.isAuthenticated()
        .then(authenticated => {
            if (authenticated) {
                this.authService.getLoggedInUser().then(result => {
                    if (result != null) {
                        if (definehome) {
                            if (result.role.toLowerCase() === 'worker' || result.role.toLowerCase() === 'sub_supplier') {
                                this.router.navigate(['/worker/safetybox']);
                                return false;
                            } else {
                                this.router.navigate(['/seller/profile']);
                                return false;
                            }
                        }

                        // tslint:disable-next-line:prefer-const
                        let ischeckRole = this.checkingRole(expectedRole, result.role.toLowerCase());
                        if (!ischeckRole) {
                            if (result.role.toLowerCase() === 'worker' || result.role.toLowerCase() === 'sub_supplier') {
                                this.router.navigate(['/worker/safetybox']);
                                return false;
                            } else if (result.role.toLowerCase() === 'seller') {
                                this.router.navigate(['/seller/profile']);
                                return false;
                            }
                        }else {

                        }
                    }else {
                        console.log('Unauthorized to open link: ' + state.url);
                        this.router.navigate(['/login']);
                        this.authService.logout();
                        return false;
                    }
                });
            } else {
                console.log('Unauthorized to open link: ' + state.url);
                this.router.navigate(['/login']);
                this.authService.logout();
                return false;
            }
        });
        return true;
    }


    checkingRole(expectedrole: any, result: string): boolean {
        if (expectedrole.length === 0) {
            return false;
        }
        return  (expectedrole.indexOf(result) > -1);
    }

}




// WEBPACK FOOTER //
// ./src/app/authentication/service/auth-guard.service.ts